var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringify } from 'query-string';
const apiGroupsBasePath = '/api-management/internal/OrganizationApiGroups';
const eulaBasePath = '/api-management/internal/ApiGroups/';
const SearchFields = ['name', 'description'];
export const apiGroupsDataProvider = context => {
    return {
        getList: async ({ filter = {}, pagination = { page: 1, perPage: 24 }, }) => {
            const url = `${context.apiUrl}${apiGroupsBasePath}?${stringify(Object.assign(Object.assign({}, getFilter(filter)), { page: pagination.page - 1, size: pagination.perPage }))}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });
            return {
                data: json.results.map((_a) => {
                    var { uuid } = _a, item = __rest(_a, ["uuid"]);
                    return (Object.assign(Object.assign({}, item), { id: uuid }));
                }) || [],
                total: json.totalElements || 0,
            };
        },
        getMany: async () => {
            return {
                data: [],
            };
        },
        getApiGroupEula: async ({ apiGroupId, filter = {} }) => {
            const url = `${context.apiUrl}${eulaBasePath}${apiGroupId}/Eulas?${stringify({
                filter: stringify(Object.assign({}, filter)),
            })}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });
            return {
                data: json.d.results[0],
            };
        },
    };
};
export const getFilter = (_a, searchFields = SearchFields) => {
    var { q } = _a, filters = __rest(_a, ["q"]);
    let result = filters;
    if (!q) {
        return filters;
    }
    // The API does not support the `q` field for fulltext search.
    // Instead, we must add a filter for each searchable field supported by this resource
    if (!searchFields || searchFields.length === 0) {
        return result;
    }
    return searchFields.reduce((acc, field) => {
        acc[field] = q;
        return acc;
    }, Object.assign({}, filters));
};
//# sourceMappingURL=apiGroups.js.map